import { DialogObject } from '@/components/dialog/dialog.types';

export const getApprovalTypeDeleteObject = ({ store, action, toggleVisiblity }: any): DialogObject => {
  return {
    title: 'settings.approvalType.delete.title',
    description: '',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.approvalType.delete.delete',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'settings.approvalType.delete.cancel',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
